var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2269 8.56898L9.21186 10.174C8.36686 10.847 7.94386 11.184 8.02686 11.559L8.03086 11.578C8.12486 11.951 8.66086 12.095 9.73286 12.382C10.3279 12.542 10.6259 12.622 10.7659 12.847L10.7729 12.859C10.9079 13.088 10.8309 13.374 10.6779 13.946L10.6379 14.096C10.2119 15.682 9.99986 16.475 10.4089 16.731C10.8179 16.987 11.4689 16.469 12.7719 15.431L14.7869 13.827C15.6329 13.153 16.0549 12.817 15.9729 12.441L15.9689 12.422C15.8739 12.049 15.3389 11.905 14.2669 11.618C13.6719 11.458 13.3739 11.378 13.2339 11.153L13.2269 11.141C13.0919 10.913 13.1689 10.627 13.3219 10.055L13.3619 9.90498C13.7869 8.31898 13.9999 7.52498 13.5909 7.26898C13.1819 7.01298 12.5299 7.53198 11.2269 8.56898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/EnergyIcon.9c1b396819dd0a3d7d7cde86474ce016.svg";
export { ForwardRef as ReactComponent };